import { Form, Button, Row, Col, Modal } from "react-bootstrap";

import useGeoLocation from "../../tools/useGeolocation";
// import { Map, MapMarker } from "react-kakao-maps-sdk";
import React, { useState, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import {
  fetchAllSpotData,
  selectDeviceInfoData,
  selectSpotInfo,
  selectSpotInfoList,
  selectStatus,
  setDeviceInfoData,
  setSpotInfoData,
} from "../../store/deviceData/deviceDataSlice";
import { SpotInfo } from "deviceDataTypes";

export default function InputForm() {
  const dispatch = useAppDispatch();
  const deviceInfoData = useAppSelector(selectDeviceInfoData);
  const spotInfoData = useAppSelector(selectSpotInfo);
  const spotInfoList = useAppSelector(selectSpotInfoList);
  const deviceType = useAppSelector((state: any) => state.deviceData.deviceType);
  const [spotInfoDataTemp, setSpotInfoDataTemp] = useState<SpotInfo>();
  const [mapOpen, setMapOpen] = useState(false);
  const { location, refreshLocation } = useGeoLocation();
  const [showModal, setShowModal] = useState(false); // 모달 상태
  const status = useAppSelector(selectStatus);

  const handleModalClose = () => {
    setSpotInfoDataTemp(spotInfoData);
    setShowModal(false);
  };
  const handleModalShow = () => {
    dispatch(fetchAllSpotData());
    setShowModal(true);
  };
  const handelModalAccept = () => {
    dispatch(setSpotInfoData(spotInfoDataTemp));
    const updatedData = {
      ...deviceInfoData,
      spot_code: spotInfoDataTemp!.id,
    };
    dispatch(setDeviceInfoData(updatedData));
    setShowModal(false);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, files } = e.target;
    if (files && files.length > 0 && ["img1", "img2", "img3"].includes(name)) {
      handleImageChange(name, files);
    } else {
      const updatedData = {
        ...deviceInfoData,
        [name]: value,
      };
      dispatch(setDeviceInfoData(updatedData));
    }
  };
  const handleImageChange = (name: string, files: FileList) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const imageDataUrl = event.target?.result as string;
      const updatedData = {
        ...deviceInfoData,
        [name]: imageDataUrl,
      };
      dispatch(setDeviceInfoData(updatedData));
    };
    reader.readAsDataURL(files[0]);
  };

  const nowLocation = {
    lat: location.coordinates?.lat ?? 35.2417951,
    lng: location.coordinates?.lng ?? 129.0834828,
  };
  const insertLocationData = () => {
    dispatch(
      setDeviceInfoData({
        ...deviceInfoData,
        lat: location.coordinates?.lat ?? 0,
        lng: location.coordinates?.lng ?? 0,
      })
    );
  };

  useEffect(() => {
    let container = document.getElementById('map');
    if (mapOpen) {
      let options = {
        center: new window.kakao.maps.LatLng(location.coordinates?.lat ?? 35.2417951, location.coordinates?.lng ?? 129.0834828),
        level: 1
      };

      let map = new window.kakao.maps.Map(container!, options);
      var markerPosition = new window.kakao.maps.LatLng(location.coordinates?.lat ?? 35.2417951, location.coordinates?.lng ?? 129.0834828);
      var marker = new window.kakao.maps.Marker({
        position: markerPosition

      });
      marker.setMap(map);
    }
  }, [mapOpen])
  return (
    <div> {status === 'loading' ? <>로딩중</> :
      <Form>
        <Form.Group controlId="formPrdId">
          <Form.Label>PRD ID</Form.Label>
          <Form.Control
            type="text"
            name="prd_id"
            value={deviceInfoData?.prd_id?.toString() || ""}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group controlId="formName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={deviceInfoData?.name || ""}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group>
          {mapOpen && (
            <div id="map" style={{ width: "100%", height: "360px" }} />
          )}
          {/* {mapOpen && (
          <Map
            center={nowLocation}
            style={{ width: "100%", height: "360px" }}
            level={1}
          >
            <MapMarker position={nowLocation}>
              <div>현재위치</div>
            </MapMarker>
          </Map>
        )} */}
          {/* <div id="map" style={{ width: "100vw", height: "100vh" }} /> */}
          <Row>
            <Col>
              {!mapOpen && (
                <Button onClick={() => setMapOpen(true)}> 지도열기 </Button>
              )}
              {mapOpen && (
                <Button onClick={() => setMapOpen(false)}> 지도닫기 </Button>
              )}

              <Button onClick={() => insertLocationData()}>현재위치입력</Button>
            </Col>
            <Col>
              <div>
                현재 위치 : <Button onClick={refreshLocation}>새로고침</Button>
              </div>
              <div>
                {location.coordinates?.lat} , {location.coordinates?.lng}
              </div>
            </Col>
          </Row>
        </Form.Group>
        <Row>
          <Col>
            <Form.Group controlId="formLat">
              <Form.Label>Latitude</Form.Label>
              <Form.Control
                type="text"
                name="lat"
                value={deviceInfoData?.lat || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formlng">
              <Form.Label>longitude</Form.Label>
              <Form.Control
                type="text"
                name="lng"
                value={deviceInfoData?.lng || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Form.Group as={Row} controlId="formSpotcode">
            <Form.Label>지점정보</Form.Label>
            <Col>
              <Form.Control
                type="text"
                name="spotcode"
                value=
                // {deviceInfoData.spot_code ==null
                //   ? `1`
                //   : "현재정보를 이용해서 생성"}
                {deviceInfoData.spot_code != null
                  ? `${deviceInfoData.spot_code}번 ${spotInfoData.spot_name}`
                  : "현재정보를 이용해서 생성"}

                onChange={handleChange}
              />
            </Col>
            <Col>
              <Button onClick={handleModalShow}>수정</Button>
              <Button onClick={() => {
                const updatedData = {
                  ...deviceInfoData,
                  spot_code: null,
                };
                dispatch(setDeviceInfoData(updatedData));
              }}>새로추가</Button>
              <Modal show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                  <Modal.Title>지점선택</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <table>
                    <thead>
                      <tr>
                        <th>선택</th>
                        <th>id</th>
                        <th>name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {spotInfoList.map((item, index) => (
                        <tr key={index} onClick={() => { }}>
                          <td>
                            <input
                              type="radio"
                              name="spotSelection"
                              value={item.id}
                              onChange={(e) => {
                                setSpotInfoDataTemp(item);
                              }}
                            />
                          </td>
                          <td>{item.id}</td>
                          <td>{item.spot_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleModalClose}>
                    취소
                  </Button>
                  <Button variant="primary" onClick={handelModalAccept}>
                    선택
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Form.Group>
        </Row>

        <Form.Group controlId="formSetTime">
          <Form.Label>Set Time ex: 2022-10-10T12:08:42.652000+09:00</Form.Label>
          <Form.Control
            type="text"
            name="set_time"
            value={deviceInfoData?.set_time}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="formEl">
          <Form.Label>EL</Form.Label>
          <Form.Control
            type="text"
            name="el"
            value={deviceInfoData?.el || ""}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="formOwner">
          <Form.Label>Owner</Form.Label>
          <Form.Control
            type="text"
            name="owner"
            value={deviceInfoData?.owner || ""}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="formUsim">
          <Form.Label>USIM</Form.Label>
          <Form.Control
            type="text"
            name="usim"
            value={deviceInfoData?.usim || ""}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="formExtendDate">
          <Form.Label>
            Extend Date ex: 2022-10-10T12:08:42.652000+09:00
          </Form.Label>
          <Form.Control
            type="text"
            name="extend_date"
            value={deviceInfoData?.extend_date || ""}
            onChange={handleChange}
          />
        </Form.Group>

        {deviceType?.toLowerCase() === "wal" && (
          <Form.Group controlId="formBase">
            <Form.Label>기준값 (Base)</Form.Label>
            <Form.Control
              type="number"
              name="base"
              value={deviceInfoData?.base || ""}
              onChange={handleChange}
              placeholder="기준값을 입력하세요"
            />
          </Form.Group>
        )}

        <Form.Group controlId="formDangerValue">
          <Form.Label>위험값 (Danger Value)</Form.Label>
          <Form.Control
            type="number"
            name="danger_value"
            value={deviceInfoData?.danger_value || ""}
            onChange={handleChange}
            placeholder="위험값을 입력하세요"
          />
        </Form.Group>

        <Form.Group controlId="formAttentionValue">
          <Form.Label>주의값 (Attention Value)</Form.Label>
          <Form.Control
            type="number"
            name="attention_value"
            value={deviceInfoData?.attention_value || ""}
            onChange={handleChange}
            placeholder="주의값을 입력하세요"
          />
        </Form.Group>

        <Form.Group controlId="formImage1">
          <Form.Label>Image1</Form.Label>
          <Form.Control type="file" name="img1" onChange={handleChange} />
          {deviceInfoData?.img1 && (
            <div>
              <img
                src={deviceInfoData.img1}
                alt="device image1"
                style={{ maxWidth: "100%" }}
              />
            </div>
          )}
        </Form.Group>
        <Form.Group controlId="formImage2">
          <Form.Label>Image2</Form.Label>
          <Form.Control type="file" name="img2" onChange={handleChange} />
          {deviceInfoData?.img2 && (
            <div>
              <img
                src={deviceInfoData.img2}
                alt="device image2"
                style={{ maxWidth: "100%" }}
              />
            </div>
          )}
        </Form.Group>
        <Form.Group controlId="formImage3">
          <Form.Label>Image3</Form.Label>
          <Form.Control type="file" name="img3" onChange={handleChange} />
          {deviceInfoData?.img3 && (
            <div>
              <img
                src={deviceInfoData.img3}
                alt="device image3"
                style={{ maxWidth: "100%" }}
              />
            </div>
          )}
        </Form.Group>
      </Form>}
    </div>
  );
}
